// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Create Account App - WV Design System Aligned
   Tokens from: https://vvevoda.github.io/WV-Design-System/
   Source CSS: vvevoda/WV-Design-System/docs/styles.css */

/* --- DS Custom Properties (scoped to avoid leaking) --- */
.create-account {
  /* Surfaces */
  --surface-page: #fafafa;
  --surface-default-container: #fdfdfd;
  --surface-top-container: #f5f5f5;
  --surface-disabled: #f5f5f5;
  --surface-action-hover: #f78958;
  --surface-error: #fff1f1;
  --surface-success: #f1f7f2;

  /* Text */
  --text-headings: #393939;
  --text-body: #464646;
  --text-captions: #666666;
  --text-placeholder: #7d7d7d;
  --text-action: #e96620;
  --text-action-hover: #f78958;
  --text-action-on-hover: #fff1eb;
  --text-action-on-pressed: #ffc7ae;
  --text-action-disabled: #979797;
  --text-action-on: #ffffff;
  --text-status-error: #de515e;
  --text-status-success: #438558;

  /* Borders */
  --border-default: #e9e9e9;
  --border-accent: #d0d0d0;
  --border-action: #f78958;
  --border-action-hover: #ffa984;
  --border-action-pressed: #e96620;
  --border-disabled: #e9e9e9;
  --border-error: #f88c90;

  /* Radii */
  --radius-s: 4px;
  --radius-m: 8px;
  --radius-xxl: 48px;

  /* Spacing */
  --padding-s: 8px;
  --padding-s-m: 12px;
  --padding-m: 16px;
  --padding-l: 24px;
  --padding-xl: 32px;
  --jumper-xxxs-tiny: 8px;

  /* Typography */
  --font-primary: 'Lato', sans-serif;
  --h5-size: 24px;
  --h5-line: 28px;
  --body-m-size: 16px;
  --body-m-line: 24px;
  --body-s-size: 14px;
  --body-s-line: 20px;
  --body-xs-size: 12px;
  --body-xs-line: 14px;
  --body-l-size: 20px;
  --body-l-line: 28px;

  /* Buttons */
  --btn-primary-bg: #e96620;
  --btn-primary-bg-hover: #f78958;
  --btn-primary-bg-pressed: #d14000;
  --btn-primary-bg-disabled: #f5f5f5;
  --btn-primary-border: #f78958;
  --btn-primary-border-hover: #ffa984;
  --btn-primary-border-pressed: #e96620;
  --btn-primary-text: #ffffff;
  --btn-primary-text-hover: #fff1eb;
  --btn-primary-text-pressed: #ffc7ae;
  --btn-border-disabled: #e9e9e9;
  --btn-border-width: 2px;
  --btn-radius: 48px;

  /* Shadow */
  --shadow-default: 0px 8px 16px 0px rgba(179, 179, 179, 0.1);
}

/* --- Layout --- */
.create-account {
  display: flex;
  justify-content: center;
  padding: 40px var(--padding-m) 80px;
  min-height: 60vh;
  font-family: var(--font-primary);
}

.create-account__card {
  width: 100%;
  max-width: 480px;
  background: var(--surface-default-container);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-m);
  padding: var(--padding-xl) var(--padding-xl);
}

.create-account__card--wide {
  max-width: 560px;
}

/* --- Tab Bar (replaces step progress) --- */
.tab-bar {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-default);
  margin-bottom: var(--padding-xl);
}

.tab-item {
  display: flex;
  align-items: center;
  gap: var(--padding-s);
  padding: var(--padding-s);
  position: relative;
  white-space: nowrap;
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  letter-spacing: 0.16px;
  font-weight: 400;
  color: var(--text-body);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.tab-item.selected {
  font-weight: 700;
  border-bottom-color: var(--border-action);
}

.tab-item:focus-visible {
  outline: none;
}

.tab-item.is-disabled {
  background: var(--surface-disabled);
  color: var(--text-action-disabled);
  cursor: not-allowed;
  pointer-events: none;
}

/* --- Title and Subtitle --- */
.create-account__title {
  font-size: var(--h5-size);
  line-height: var(--h5-line);
  font-weight: 900;
  color: var(--text-headings);
  margin: 0 0 var(--padding-s);
}

.create-account__subtitle {
  font-size: var(--body-s-size);
  line-height: var(--body-s-line);
  color: var(--text-captions);
  margin: 0 0 var(--padding-l);
}

/* --- Snackbar (replaces help text) --- */
.snackbar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background: var(--surface-default-container);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-m);
  box-shadow: var(--shadow-default);
  overflow: clip;
  margin-bottom: var(--padding-m);
}

.snackbar-content {
  display: flex;
  gap: var(--padding-m);
  align-items: flex-start;
  padding: var(--padding-m);
  width: 100%;
}

.snackbar-icon-text {
  display: flex;
  flex: 1 0 0;
  gap: var(--padding-s);
  align-items: center;
  align-self: stretch;
  min-width: 0;
}

.snackbar-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 20px;
  flex-shrink: 0;
  font-size: var(--body-l-size);
  line-height: var(--body-m-line);
  text-align: center;
  color: var(--text-action);
}

.snackbar-text {
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: var(--jumper-xxxs-tiny);
  align-items: flex-start;
  min-width: 0;
}

p.snackbar-body,
.snackbar-body {
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  letter-spacing: 0.16px;
  color: var(--text-body);
  margin: 0;
}

/* --- Form Overrides --- */
.create-account .wvus-form {
  max-width: 100%;
}

.create-account .form-group {
  margin-bottom: var(--padding-l);
}

.create-account .form-group label {
  font-size: var(--body-s-size);
  line-height: var(--body-s-line);
  font-weight: 400;
  color: var(--text-body);
  margin-bottom: var(--padding-s);
}

.create-account .form-control {
  height: auto;
  padding: var(--padding-s) var(--padding-s-m);
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  border: 1px solid var(--border-accent);
  border-radius: var(--radius-m);
  background-color: var(--surface-default-container);
  color: var(--text-body);
  transition: border-color 0.15s ease;
  position: relative;
}

.create-account .form-control:focus {
  border-color: var(--border-action);
  box-shadow: none;
  outline: 2px solid var(--border-action);
  outline-offset: 3px;
}

.create-account .form-control:disabled,
.create-account .form-control[readonly] {
  background-color: var(--surface-disabled);
  border-color: var(--border-disabled);
  color: var(--text-action-disabled);
  cursor: not-allowed;
}

.create-account .form-control::placeholder {
  color: var(--text-placeholder);
}

/* Validation icon centering - match input height, flexbox center the glyph.
   The wrapper height changes in error state (includes help-block),
   so percentage-based top breaks. Fixed height matches the input instead. */
.create-account .form-group.has-icon .fa {
  top: 0;
  height: 42px;
  transform: none;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

/* --- Submit Button (DS Primary, Size M) --- */
.create-account__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--padding-s);
  width: 100%;
  padding: var(--padding-s) var(--padding-l);
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  font-weight: 400;
  letter-spacing: 0.01em;
  text-decoration: none;
  text-align: center;
  border-width: var(--btn-border-width);
  border-style: solid;
  border-radius: var(--btn-radius);
  background: var(--btn-primary-bg);
  border-color: var(--btn-primary-border);
  color: var(--btn-primary-text);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  position: relative;
  overflow: clip;
  margin-top: var(--padding-s);
  box-shadow: none;
  outline: none;
  text-transform: none;
}

.create-account__submit:hover:not(:disabled) {
  background: var(--btn-primary-bg-hover);
  border-color: var(--btn-primary-border-hover);
  color: var(--btn-primary-text-hover);
}

.create-account__submit:active:not(:disabled) {
  background: var(--btn-primary-bg-pressed);
  border-color: var(--btn-primary-border-pressed);
  color: var(--btn-primary-text-pressed);
}

.create-account__submit:focus-visible {
  outline: none;
}

.create-account__submit:focus-visible::after {
  content: '';
  position: absolute;
  inset: -6px;
  border: var(--btn-border-width) solid var(--btn-primary-border);
  border-radius: var(--btn-radius);
  pointer-events: none;
}

.create-account__submit:disabled {
  background: var(--btn-primary-bg-disabled);
  border-color: var(--btn-border-disabled);
  color: var(--text-action-disabled);
  cursor: not-allowed;
}

/* --- Divider --- */
.create-account__divider {
  display: flex;
  align-items: center;
  margin: var(--padding-l) 0;
  width: 100%;
  flex-basis: 100%;
}

.create-account__divider::before,
.create-account__divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background-color: var(--border-default);
}

.create-account__divider-text {
  padding: 0 var(--padding-m);
  font-size: var(--body-xs-size);
  line-height: var(--body-xs-line);
  color: var(--text-placeholder);
  text-transform: lowercase;
}

/* --- Toggle (DS Text Link pattern) --- */
.create-account__toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--padding-s);
  width: auto;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-primary);
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--text-action);
  text-decoration: none;
  transition: color 0.15s ease;
}

.create-account__toggle:hover {
  color: var(--text-action-hover);
}

.create-account__toggle:hover span {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}

.create-account__toggle:focus-visible {
  outline: 2px solid var(--border-action);
  outline-offset: 6px;
  border-radius: var(--radius-s);
}

.create-account__toggle i {
  font-size: var(--body-xs-size);
  color: inherit;
  transition: transform 0.25s ease;
}

.create-account__toggle[aria-expanded="true"] i {
  transform: rotate(180deg);
}

/* --- Expandable Section --- */
.create-account__expandable {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.25s ease;
  opacity: 0;
  width: 100%;
  flex-basis: 100%;
}

.create-account__expandable--open {
  max-height: 400px;
  opacity: 1;
  overflow: visible;
}

.create-account__expandable-inner {
  padding-top: var(--padding-l);
  width: 100%;
}

/* --- Error Styling (DS Alert Error) --- */
.create-account__error-banner .error-message,
.create-account .wv-create-account-error-message.error-message {
  display: flex;
  align-items: flex-start;
  gap: var(--padding-s);
  padding: var(--padding-s-m);
  background-color: var(--surface-error);
  border: 1px solid var(--border-error);
  border-radius: var(--radius-s);
  color: var(--text-status-error);
  font-size: var(--body-s-size);
  line-height: var(--body-s-line);
  margin-bottom: var(--padding-l);
  animation: create-account__shake 0.4s ease;
}

.create-account .has-error .form-control {
  border-color: var(--border-error);
}

.create-account .has-error .help-block {
  color: var(--text-status-error);
  font-size: var(--body-xs-size);
  line-height: var(--body-xs-line);
  margin-top: var(--padding-s);
}

@keyframes create-account__shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-2px); }
  80% { transform: translateX(2px); }
}

/* --- Password Hint --- */
.create-account__password-hint {
  font-size: var(--body-xs-size);
  line-height: var(--body-xs-line);
  letter-spacing: 0.01em;
  color: var(--text-captions);
  margin: calc(-1 * var(--padding-s-m)) 0 var(--padding-m);
}

/* --- Confirmation --- */
.create-account__confirmation {
  text-align: center;
  padding: var(--padding-l) 0;
}

.create-account__confirmation-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--surface-success);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--padding-l);
}

.create-account__confirmation-icon i {
  font-size: 28px;
  color: var(--text-status-success);
}

.create-account__confirmation-text {
  font-size: var(--body-m-size);
  line-height: var(--body-m-line);
  color: var(--text-captions);
  margin: 0 0 var(--padding-s-m);
}

.create-account__confirmation-text i {
  margin-right: var(--padding-s);
  color: var(--text-captions);
}

.create-account__confirmation-cta {
  margin-top: var(--padding-l);
}

/* --- Responsive --- */
@media (max-width: 767px) {
  .create-account {
    padding: var(--padding-l) var(--padding-m) 60px;
  }
  .create-account__card {
    padding: var(--padding-l) var(--padding-l);
    border-radius: var(--radius-m);
  }
  .create-account__card--wide {
    max-width: 100%;
  }
  .create-account__title {
    font-size: var(--body-l-size);
    line-height: var(--body-l-line);
  }
  .tab-item {
    font-size: var(--body-s-size);
    line-height: var(--body-s-line);
  }
}
`, "",{"version":3,"sources":["webpack://./src/create-account.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;;EAE1B,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;;EAE9B,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;;EAEvB,UAAU;EACV,eAAe;EACf,eAAe;EACf,kBAAkB;;EAElB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;;EAEvB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;;EAEnB,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;;EAElB,WAAW;EACX,2DAA2D;AAC7D;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,uCAAuC;EACvC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,4CAA4C;EAC5C,uCAAuC;EACvC,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;EAC9B,kDAAkD;EAClD,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;EACzC,oCAAoC;EACpC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;4EAE4E;AAC5E;EACE,MAAM;EACN,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;EAC9B,eAAe;EACf,4EAA4E;EAC5E,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,+DAA+D;EAC/D,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,gBAAgB;EAChB;gCAC8B;EAC9B,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE;IACE,+CAA+C;EACjD;EACA;IACE,0CAA0C;IAC1C,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;EACA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;AACF","sourcesContent":["/* Create Account App - WV Design System Aligned\n   Tokens from: https://vvevoda.github.io/WV-Design-System/\n   Source CSS: vvevoda/WV-Design-System/docs/styles.css */\n\n/* --- DS Custom Properties (scoped to avoid leaking) --- */\n.create-account {\n  /* Surfaces */\n  --surface-page: #fafafa;\n  --surface-default-container: #fdfdfd;\n  --surface-top-container: #f5f5f5;\n  --surface-disabled: #f5f5f5;\n  --surface-action-hover: #f78958;\n  --surface-error: #fff1f1;\n  --surface-success: #f1f7f2;\n\n  /* Text */\n  --text-headings: #393939;\n  --text-body: #464646;\n  --text-captions: #666666;\n  --text-placeholder: #7d7d7d;\n  --text-action: #e96620;\n  --text-action-hover: #f78958;\n  --text-action-on-hover: #fff1eb;\n  --text-action-on-pressed: #ffc7ae;\n  --text-action-disabled: #979797;\n  --text-action-on: #ffffff;\n  --text-status-error: #de515e;\n  --text-status-success: #438558;\n\n  /* Borders */\n  --border-default: #e9e9e9;\n  --border-accent: #d0d0d0;\n  --border-action: #f78958;\n  --border-action-hover: #ffa984;\n  --border-action-pressed: #e96620;\n  --border-disabled: #e9e9e9;\n  --border-error: #f88c90;\n\n  /* Radii */\n  --radius-s: 4px;\n  --radius-m: 8px;\n  --radius-xxl: 48px;\n\n  /* Spacing */\n  --padding-s: 8px;\n  --padding-s-m: 12px;\n  --padding-m: 16px;\n  --padding-l: 24px;\n  --padding-xl: 32px;\n  --jumper-xxxs-tiny: 8px;\n\n  /* Typography */\n  --font-primary: 'Lato', sans-serif;\n  --h5-size: 24px;\n  --h5-line: 28px;\n  --body-m-size: 16px;\n  --body-m-line: 24px;\n  --body-s-size: 14px;\n  --body-s-line: 20px;\n  --body-xs-size: 12px;\n  --body-xs-line: 14px;\n  --body-l-size: 20px;\n  --body-l-line: 28px;\n\n  /* Buttons */\n  --btn-primary-bg: #e96620;\n  --btn-primary-bg-hover: #f78958;\n  --btn-primary-bg-pressed: #d14000;\n  --btn-primary-bg-disabled: #f5f5f5;\n  --btn-primary-border: #f78958;\n  --btn-primary-border-hover: #ffa984;\n  --btn-primary-border-pressed: #e96620;\n  --btn-primary-text: #ffffff;\n  --btn-primary-text-hover: #fff1eb;\n  --btn-primary-text-pressed: #ffc7ae;\n  --btn-border-disabled: #e9e9e9;\n  --btn-border-width: 2px;\n  --btn-radius: 48px;\n\n  /* Shadow */\n  --shadow-default: 0px 8px 16px 0px rgba(179, 179, 179, 0.1);\n}\n\n/* --- Layout --- */\n.create-account {\n  display: flex;\n  justify-content: center;\n  padding: 40px var(--padding-m) 80px;\n  min-height: 60vh;\n  font-family: var(--font-primary);\n}\n\n.create-account__card {\n  width: 100%;\n  max-width: 480px;\n  background: var(--surface-default-container);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-m);\n  padding: var(--padding-xl) var(--padding-xl);\n}\n\n.create-account__card--wide {\n  max-width: 560px;\n}\n\n/* --- Tab Bar (replaces step progress) --- */\n.tab-bar {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--border-default);\n  margin-bottom: var(--padding-xl);\n}\n\n.tab-item {\n  display: flex;\n  align-items: center;\n  gap: var(--padding-s);\n  padding: var(--padding-s);\n  position: relative;\n  white-space: nowrap;\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  letter-spacing: 0.16px;\n  font-weight: 400;\n  color: var(--text-body);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.tab-item.selected {\n  font-weight: 700;\n  border-bottom-color: var(--border-action);\n}\n\n.tab-item:focus-visible {\n  outline: none;\n}\n\n.tab-item.is-disabled {\n  background: var(--surface-disabled);\n  color: var(--text-action-disabled);\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* --- Title and Subtitle --- */\n.create-account__title {\n  font-size: var(--h5-size);\n  line-height: var(--h5-line);\n  font-weight: 900;\n  color: var(--text-headings);\n  margin: 0 0 var(--padding-s);\n}\n\n.create-account__subtitle {\n  font-size: var(--body-s-size);\n  line-height: var(--body-s-line);\n  color: var(--text-captions);\n  margin: 0 0 var(--padding-l);\n}\n\n/* --- Snackbar (replaces help text) --- */\n.snackbar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  background: var(--surface-default-container);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-m);\n  box-shadow: var(--shadow-default);\n  overflow: clip;\n  margin-bottom: var(--padding-m);\n}\n\n.snackbar-content {\n  display: flex;\n  gap: var(--padding-m);\n  align-items: flex-start;\n  padding: var(--padding-m);\n  width: 100%;\n}\n\n.snackbar-icon-text {\n  display: flex;\n  flex: 1 0 0;\n  gap: var(--padding-s);\n  align-items: center;\n  align-self: stretch;\n  min-width: 0;\n}\n\n.snackbar-icon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  width: 20px;\n  flex-shrink: 0;\n  font-size: var(--body-l-size);\n  line-height: var(--body-m-line);\n  text-align: center;\n  color: var(--text-action);\n}\n\n.snackbar-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  gap: var(--jumper-xxxs-tiny);\n  align-items: flex-start;\n  min-width: 0;\n}\n\np.snackbar-body,\n.snackbar-body {\n  font-family: var(--font-primary);\n  font-weight: 400;\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  letter-spacing: 0.16px;\n  color: var(--text-body);\n  margin: 0;\n}\n\n/* --- Form Overrides --- */\n.create-account .wvus-form {\n  max-width: 100%;\n}\n\n.create-account .form-group {\n  margin-bottom: var(--padding-l);\n}\n\n.create-account .form-group label {\n  font-size: var(--body-s-size);\n  line-height: var(--body-s-line);\n  font-weight: 400;\n  color: var(--text-body);\n  margin-bottom: var(--padding-s);\n}\n\n.create-account .form-control {\n  height: auto;\n  padding: var(--padding-s) var(--padding-s-m);\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  border: 1px solid var(--border-accent);\n  border-radius: var(--radius-m);\n  background-color: var(--surface-default-container);\n  color: var(--text-body);\n  transition: border-color 0.15s ease;\n  position: relative;\n}\n\n.create-account .form-control:focus {\n  border-color: var(--border-action);\n  box-shadow: none;\n  outline: 2px solid var(--border-action);\n  outline-offset: 3px;\n}\n\n.create-account .form-control:disabled,\n.create-account .form-control[readonly] {\n  background-color: var(--surface-disabled);\n  border-color: var(--border-disabled);\n  color: var(--text-action-disabled);\n  cursor: not-allowed;\n}\n\n.create-account .form-control::placeholder {\n  color: var(--text-placeholder);\n}\n\n/* Validation icon centering - match input height, flexbox center the glyph.\n   The wrapper height changes in error state (includes help-block),\n   so percentage-based top breaks. Fixed height matches the input instead. */\n.create-account .form-group.has-icon .fa {\n  top: 0;\n  height: 42px;\n  transform: none;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/* --- Submit Button (DS Primary, Size M) --- */\n.create-account__submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--padding-s);\n  width: 100%;\n  padding: var(--padding-s) var(--padding-l);\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  font-weight: 400;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  text-align: center;\n  border-width: var(--btn-border-width);\n  border-style: solid;\n  border-radius: var(--btn-radius);\n  background: var(--btn-primary-bg);\n  border-color: var(--btn-primary-border);\n  color: var(--btn-primary-text);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  position: relative;\n  overflow: clip;\n  margin-top: var(--padding-s);\n  box-shadow: none;\n  outline: none;\n  text-transform: none;\n}\n\n.create-account__submit:hover:not(:disabled) {\n  background: var(--btn-primary-bg-hover);\n  border-color: var(--btn-primary-border-hover);\n  color: var(--btn-primary-text-hover);\n}\n\n.create-account__submit:active:not(:disabled) {\n  background: var(--btn-primary-bg-pressed);\n  border-color: var(--btn-primary-border-pressed);\n  color: var(--btn-primary-text-pressed);\n}\n\n.create-account__submit:focus-visible {\n  outline: none;\n}\n\n.create-account__submit:focus-visible::after {\n  content: '';\n  position: absolute;\n  inset: -6px;\n  border: var(--btn-border-width) solid var(--btn-primary-border);\n  border-radius: var(--btn-radius);\n  pointer-events: none;\n}\n\n.create-account__submit:disabled {\n  background: var(--btn-primary-bg-disabled);\n  border-color: var(--btn-border-disabled);\n  color: var(--text-action-disabled);\n  cursor: not-allowed;\n}\n\n/* --- Divider --- */\n.create-account__divider {\n  display: flex;\n  align-items: center;\n  margin: var(--padding-l) 0;\n  width: 100%;\n  flex-basis: 100%;\n}\n\n.create-account__divider::before,\n.create-account__divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background-color: var(--border-default);\n}\n\n.create-account__divider-text {\n  padding: 0 var(--padding-m);\n  font-size: var(--body-xs-size);\n  line-height: var(--body-xs-line);\n  color: var(--text-placeholder);\n  text-transform: lowercase;\n}\n\n/* --- Toggle (DS Text Link pattern) --- */\n.create-account__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--padding-s);\n  width: auto;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-primary);\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: var(--text-action);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.create-account__toggle:hover {\n  color: var(--text-action-hover);\n}\n\n.create-account__toggle:hover span {\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 3px;\n}\n\n.create-account__toggle:focus-visible {\n  outline: 2px solid var(--border-action);\n  outline-offset: 6px;\n  border-radius: var(--radius-s);\n}\n\n.create-account__toggle i {\n  font-size: var(--body-xs-size);\n  color: inherit;\n  transition: transform 0.25s ease;\n}\n\n.create-account__toggle[aria-expanded=\"true\"] i {\n  transform: rotate(180deg);\n}\n\n/* --- Expandable Section --- */\n.create-account__expandable {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n              opacity 0.25s ease;\n  opacity: 0;\n  width: 100%;\n  flex-basis: 100%;\n}\n\n.create-account__expandable--open {\n  max-height: 400px;\n  opacity: 1;\n  overflow: visible;\n}\n\n.create-account__expandable-inner {\n  padding-top: var(--padding-l);\n  width: 100%;\n}\n\n/* --- Error Styling (DS Alert Error) --- */\n.create-account__error-banner .error-message,\n.create-account .wv-create-account-error-message.error-message {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--padding-s);\n  padding: var(--padding-s-m);\n  background-color: var(--surface-error);\n  border: 1px solid var(--border-error);\n  border-radius: var(--radius-s);\n  color: var(--text-status-error);\n  font-size: var(--body-s-size);\n  line-height: var(--body-s-line);\n  margin-bottom: var(--padding-l);\n  animation: create-account__shake 0.4s ease;\n}\n\n.create-account .has-error .form-control {\n  border-color: var(--border-error);\n}\n\n.create-account .has-error .help-block {\n  color: var(--text-status-error);\n  font-size: var(--body-xs-size);\n  line-height: var(--body-xs-line);\n  margin-top: var(--padding-s);\n}\n\n@keyframes create-account__shake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-4px); }\n  40% { transform: translateX(4px); }\n  60% { transform: translateX(-2px); }\n  80% { transform: translateX(2px); }\n}\n\n/* --- Password Hint --- */\n.create-account__password-hint {\n  font-size: var(--body-xs-size);\n  line-height: var(--body-xs-line);\n  letter-spacing: 0.01em;\n  color: var(--text-captions);\n  margin: calc(-1 * var(--padding-s-m)) 0 var(--padding-m);\n}\n\n/* --- Confirmation --- */\n.create-account__confirmation {\n  text-align: center;\n  padding: var(--padding-l) 0;\n}\n\n.create-account__confirmation-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: var(--surface-success);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--padding-l);\n}\n\n.create-account__confirmation-icon i {\n  font-size: 28px;\n  color: var(--text-status-success);\n}\n\n.create-account__confirmation-text {\n  font-size: var(--body-m-size);\n  line-height: var(--body-m-line);\n  color: var(--text-captions);\n  margin: 0 0 var(--padding-s-m);\n}\n\n.create-account__confirmation-text i {\n  margin-right: var(--padding-s);\n  color: var(--text-captions);\n}\n\n.create-account__confirmation-cta {\n  margin-top: var(--padding-l);\n}\n\n/* --- Responsive --- */\n@media (max-width: 767px) {\n  .create-account {\n    padding: var(--padding-l) var(--padding-m) 60px;\n  }\n  .create-account__card {\n    padding: var(--padding-l) var(--padding-l);\n    border-radius: var(--radius-m);\n  }\n  .create-account__card--wide {\n    max-width: 100%;\n  }\n  .create-account__title {\n    font-size: var(--body-l-size);\n    line-height: var(--body-l-line);\n  }\n  .tab-item {\n    font-size: var(--body-s-size);\n    line-height: var(--body-s-line);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
